module.exports = __webpack_public_path__ + "img/61.72855c1a.jpg";